import ProfileService from '../services/permissions.service';

const permissionGuard = {
  'permission-guard': {
    inserted: async function(el, binding, vNode) {
      const action = binding.value;
      const allow = await ProfileService.canExecute(action);
      if (!allow) {
        // select
        if (vNode.elm.children[0] && vNode.elm.children[0].children.length > 0) {
          vNode.elm.children[0].classList.add('disabled');
        } else {
          vNode.elm.classList.add('disabled');
        }
        vNode.elm.disabled = true;
        if (vNode.tag === 'gl-button') {
          vNode.elm.isDisabled = true;
        }
      }
    }
  }
};

export { permissionGuard };
